import React, { useState, useEffect, useRef } from "react";
// import './CustomerMaster.css'
import axios from "../../../axiosInstance";
import { useNavigate, useLocation } from "react-router-dom";
import { Alert } from "@mui/material";
import { Button } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Modal from "react-modal";
import { IconButton } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import CloseIcon from "@mui/icons-material/Close";
import { ClipLoader } from "react-spinners";
import { Helmet } from "react-helmet-async";
import "@react-pdf-viewer/core/lib/styles/index.css";
import DownloadingOutlinedIcon from "@mui/icons-material/DownloadingOutlined";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";

import { X, Download } from "lucide-react";

import Admin from "../../CompanyAdmin/AdminHome/SideBar/Admin";

const config = {
    cUrl: "https://api.countrystatecity.in/v1/countries/IN",
    ckey: "NHhvOEcyWk50N2Vna3VFTE00bFp3MjFKR0ZEOUhkZlg4RTk1MlJlaA==",
};

const ViewVehicleJourneyInfo = () => {
    const [alertInfo, setAlertInfo] = useState({
        show: false,
        message: "",
        severity: "info",
    });
    const { location, state } = useLocation();
    // const { id, AccidentVehicleCode } = location.state || {};
    console.log("state", state);
    const navigate = useNavigate();
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");
    const [comingData, setComingData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [currentCustomerService, setCurrentCustomerService] = useState(null);
    const [serviceDetails, setServiceDetails] = useState(null);
    console.log("serivciedata", serviceDetails);
    const [IsReadOnly, setIsReadOnly] = useState(true);

    const [selectedImage, setSelectedImage] = useState(null);
    const openModal = (url) => setSelectedImage(url);
    const closeModal = () => setSelectedImage(null);

    const [formData, setFormData] = useState({});
    console.log("formdat87324", formData);

    useEffect(() => {
        console.log("token", token, userId);
        if (token === "" || userId === "") {
            navigate("/");
        }
        setCurrentCustomerService(state.service);
        setServiceDetails(`${state.service}Details`);
        getDataById(state.id, state.AccidentVehicleCode, state.service);
    }, [state]);

    const getDataById = async (id, AccidentVehicleCode, service) => {
        console.log(
            "id, AccidentVehicleCode, service",
            id,
            AccidentVehicleCode,
            service
        );
        console.log(
            `${process.env.REACT_APP_BACKEND_URL}/api/getParticularUnfilteredAccidentVehicleById/${id}/${service}/${AccidentVehicleCode}`
        );
        const response = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/api/getParticularUnfilteredAccidentVehicleById/${id}/${service}/${AccidentVehicleCode}`,
            { headers: { Authorization: `Bearer ${token}` } }
        );
        console.log("daat", response.data);

        console.log("==========================================");
        console.log(response.data.data[0]);

        setFormData({
            customer: response.data.data[0].customer,
            vehicle: response.data.data[0].vehicle,
            [`${service}Details`]: response.data.data[0][`${service}Details`],
        });
    };

    const handleBack = () => {
        navigate(-1);
    };

    const formatToIST = (utcDate) => {
        if (!utcDate) return "";
        return new Date(utcDate).toLocaleString("en-IN", {
            timeZone: "Asia/Kolkata",
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        // const validationMessage = validateForm();
        // if (validationMessage) {
        //   setAlertInfo({ show: true, message: validationMessage, severity: 'error' });
        //   setIsLoading(false); // Set isLoading to false if there is a validation error
        //   return;
        // }
        console.log("Form data submitted:", formData);
        setAlertInfo({ ...alertInfo, show: false });

        const formDataObj = new FormData();
        for (const key in formData) {
            if (formData[key]) {
                if (formData[key] instanceof File) {
                    formDataObj.append(key, formData[key], formData[key].name);
                } else if (
                    key === "vehicleNo" ||
                    key === "chassisNo" ||
                    key === "engineNo" ||
                    key === "make" ||
                    key === "model" ||
                    key === "year" ||
                    key === "type" ||
                    key === "application" ||
                    key === "GVW" ||
                    key === "ULW" ||
                    key === "InsuranceName" ||
                    key === "fleetSize"
                ) {
                    continue;
                } else {
                    formDataObj.append(key, formData[key]);
                }
            }
        }

        for (let pair of formDataObj.entries()) {
            console.log(`${pair[0]}:`, pair[1]);
        }

        try {
            const response = await axios({
                method: "PUT",
                url: `${process.env.REACT_APP_BACKEND_URL}/api/customerUpdate/${state.id}/${userId}`,
                data: formDataObj,
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            console.log("response", response.data);
            setIsLoading(false);
            setAlertInfo({
                show: true,
                message: response.data.message,
                severity: "success",
            });
            setTimeout(() => {
                navigate(-1);
            }, 2000);
        } catch (error) {
            console.error("Error during form submission:", error);
            setIsLoading(false);
            const errorMessage = error.response?.data?.message || "An error occurred";
            if (errorMessage === "jwt expired") {
                setAlertInfo({
                    show: true,
                    message: "Your session has expired. Redirecting to login...",
                    severity: "error",
                });
                setTimeout(() => {
                    window.location.href = "/";
                }, 2000);
            } else {
                setAlertInfo({ show: true, message: errorMessage, severity: "error" });
            }
        }
    };

    const formatLabel = (text) => {
        if (!text) return "";
        return text
            .replace(/([a-z])([A-Z])/g, "$1 $2") // insert space before capitals
            .replace(/^./, (str) => str.toUpperCase()); // capitalize first letter
    };

    return (
        <div>
            <Admin />
            <Helmet>
                <title>Customer Info Edit - Claimpro</title>
                <meta name="description" content="Edit the Customer Information." />
                <meta
                    name="keywords"
                    content="Vehicle Accidents, accident trucks,  Customer Service, Claimpro, Claim pro Assist, Claimpro Assist ,Accidental repair ,Motor Insurance claim,Advocate services ,Crane service ,On site repair,Accident Management"
                />
                <link rel="canonical" href={`https://claimpro.in/CustomerMasterEdit`} />
            </Helmet>
            <form
                onSubmit={handleSubmit}
                className="Customer-master-form font-satoshi"
            >
                <div
                    style={{ display: "flex", marginRight: "10px", marginBottom: "10px" }}
                >
                    <Button
                        startIcon={<ArrowBackIcon />}
                        style={{ background: "none", color: "#077ede" }}
                        onClick={handleBack}
                    />

                    <div class="header-container">
                        <h2 className="bigtitle">Customer Information</h2>
                    </div>
                </div>

                <div className="form-row">
                    <label className="form-field">
                        Customer ID:
                        <input
                            type="text"
                            className="form-control"
                            name="id"
                            value={formData?.customer?.id || ""}
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>

                    <label className="form-field">
                        Customer Name:
                        <input
                            type="text"
                            className="form-control"
                            name="CustomerName"
                            value={formData?.customer?.CustomerName || ""}
                            readOnly={IsReadOnly}
                            required
                        />
                    </label>

                    <label className="form-field">
                        Customer Phone:
                        <input
                            type="text"
                            className="form-control"
                            name="CustomerPhone"
                            value={formData?.customer?.CustomerPhone || ""}
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>

                    <label className="form-field">
                        Email:
                        <input
                            type="text"
                            className="form-control"
                            name="email"
                            value={formData?.customer?.email || ""}
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>

                    <label className="form-field">
                        Address:
                        <input
                            type="text"
                            className="form-control"
                            name="address"
                            value={formData?.customer?.address || ""}
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>

                    <label className="form-field">
                        State:
                        <input
                            type="text"
                            className="form-control"
                            name="state"
                            value={formData?.customer?.state || ""}
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>

                    <label className="form-field">
                        City:
                        <input
                            type="text"
                            className="form-control"
                            name="city"
                            value={formData?.customer?.city || ""}
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>

                    <label className="form-field">
                        Pincode:
                        <input
                            type="text"
                            className="form-control"
                            name="pincode"
                            value={formData?.customer?.pincode || ""}
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>

                    <label className="form-field">
                        Customer Type:
                        <input
                            type="text"
                            className="form-control"
                            name="CustomerType"
                            value={formData?.customer?.CustomerType || ""}
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>

                    <label className="form-field">
                        Reg. No.:
                        <input
                            type="text"
                            className="form-control"
                            name="reg"
                            value={formData?.customer?.reg || ""}
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>

                    <label className="form-field">
                        Order Status:
                        <input
                            type="text"
                            className="form-control"
                            name="orderStatus"
                            value={
                                formData[serviceDetails]?.completeOrder === 1 &&
                                    formData[serviceDetails]?.closeOrder === 0
                                    ? "Completed"
                                    : formData[serviceDetails]?.completeOrder === 0 &&
                                        formData[serviceDetails]?.closeOrder === 0
                                        ? "Pending"
                                        : "Cancelled"
                            }
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>

                    <label className="form-field">
                        Created At:
                        <input
                            type="text"
                            className="form-control"
                            name="createdAt"
                            value={formatToIST(formData?.customer?.createdAt || "")}
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>

                    <label className="form-field">
                        Issue Occurred:
                        <input
                            type="text"
                            className="form-control"
                            name="issue_occured"
                            value={formData?.customer?.issue_occured || ""}
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>
                </div>

                <div
                    style={{ display: "flex", marginRight: "10px", marginBottom: "10px" }}
                >
                    {/* <Button startIcon={<ArrowBackIcon />} style={{ background: "none", color: "#077ede" }} onClick={handleBack} /> */}

                    <div class="header-container">
                        <h2 className="bigtitle">Vehicle Information</h2>
                    </div>
                </div>

                <div className="form-row">
                    <label className="form-field">
                        Customer Representative Name:
                        <input
                            type="text"
                            className="form-control"
                            name="driverName"
                            value={formData?.vehicle?.driverName || ""}
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>

                    <label className="form-field">
                        Customer Representative No.:
                        <input
                            type="text"
                            className="form-control"
                            name="driverNumber"
                            value={formData?.vehicle?.driverNumber || ""}
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>

                    <label className="form-field">
                        Vehicle No.:
                        <input
                            type="text"
                            className="form-control"
                            name="vehicleNo"
                            value={formData?.vehicle?.vehicleNo || ""}
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>

                    <label className="form-field">
                        Chassis No.:
                        <input
                            type="text"
                            className="form-control"
                            name="chassisNo"
                            value={formData?.vehicle?.chassisNo || ""}
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>

                    <label className="form-field">
                        Engine No.:
                        <input
                            type="text"
                            className="form-control"
                            name="engineNo"
                            value={formData?.vehicle?.engineNo || ""}
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>

                    <label className="form-field">
                        Make:
                        <input
                            type="text"
                            className="form-control"
                            name="make"
                            value={formData?.vehicle?.make || ""}
                            readOnly={IsReadOnly}
                            required
                        />
                    </label>

                    <label className="form-field">
                        Model:
                        <input
                            type="text"
                            className="form-control"
                            name="model"
                            value={formData?.vehicle?.model || ""}
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>

                    <label className="form-field">
                        Year:
                        <input
                            type="text"
                            className="form-control"
                            name="year"
                            value={formData?.vehicle?.year || ""}
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>

                    <label className="form-field">
                        GVW:
                        <input
                            type="text"
                            className="form-control"
                            name="GVW"
                            value={formData?.vehicle?.GVW || ""}
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>

                    <label className="form-field">
                        Insurance Name:
                        <input
                            type="text"
                            className="form-control"
                            name="InsuranceName"
                            value={formData?.vehicle?.InsuranceName || ""}
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>

                    <label className="form-field">
                        Insurance Valid Upto:
                        <input
                            type="text"
                            className="form-control"
                            name="InsuranceValidUpto"
                            value={formData?.vehicle?.InsuranceValidUpto || ""}
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>

                    <label className="form-field"></label>
                </div>

                <div
                    style={{ display: "flex", marginRight: "10px", marginBottom: "10px" }}
                >
                    {/* <Button startIcon={<ArrowBackIcon />} style={{ background: "none", color: "#077ede" }} onClick={handleBack} /> */}

                    <div class="header-container">
                        <h2 className="bigtitle">Order Placed Information</h2>
                    </div>
                </div>

                <label className="form-field">
                    Order Date:
                    <input
                        type="text"
                        className="form-control"
                        name="systemDate"
                        value={formatToIST(formData[serviceDetails]?.systemDate) || ""}
                        required
                        readOnly={IsReadOnly}
                    />
                </label>
                <label className="form-field">
                    Pickup Location:
                    <input
                        type="text"
                        className="form-control"
                        name="pickupLocation"
                        value={formData?.customer?.pickupLocation || ""}
                        required
                        readOnly={IsReadOnly}
                    />
                </label>

                <label className="form-field">
                    Drop Location:
                    <input
                        type="text"
                        className="form-control"
                        name="dropLocation"
                        value={formData?.customer?.dropLocation || ""}
                        required
                        readOnly={IsReadOnly}
                    />
                </label>

                <div className="form-row">
                    <label className="form-field">
                        Selected Service:
                        <input
                            type="text"
                            className="form-control"
                            name="venodorType"
                            value={formatLabel(formData?.vehicle?.vendorType || "")}
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>

                    <label className="form-field">
                        Selected Inner Service:
                        <input
                            type="text"
                            className="form-control"
                            name="chooseFromSelectedServiceFinal"
                            value={formatLabel(
                                formData?.vehicle?.chooseFromSelectedServiceFinal || ""
                            )}
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>

                    <label className="form-field">
                        Is Material Loaded:
                        <input
                            type="text"
                            className="form-control"
                            name="isMaterialLoaded"
                            value={formData?.vehicle?.isMaterialLoaded ? "Yes" : "No"}
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>

                    <label className="form-field">
                        Quantity:
                        <input
                            type="text"
                            className="form-control"
                            name="quantity"
                            value={formData?.vehicle?.quantity || ""}
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>
                </div>

                <div className="form-row">
                    {formData?.customer?.images &&
                        Object.entries(formData.customer.images).map(([title, url]) => (
                            <label className="form-field" key={title}>
                                {title}:
                                <img
                                    src={url}
                                    alt={title}
                                    className="vehicle-image pt-1 cursor-pointer"
                                    style={{
                                        objectFit: "contain",
                                        marginTop: "1rem",
                                        objectFit: "contain",
                                        marginTop: "1rem",
                                        height: "200px",
                                        width: "100%",
                                        boxShadow: "rgba(0, 0, 0, 0.1) 2px 2px 20px 13px",
                                        borderRadius: "10%",
                                        boxShadow: "rgba(0, 0, 0, 0.1) 2px 2px 20px 13px",
                                        borderRadius: "10%",
                                    }}
                                    onClick={() => openModal(url)}
                                />
                            </label>
                        ))}
                    {/* Modal */}
                    {selectedImage && (
                        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                            <div className="relative rounded-2xl shadow-lg max-w-3xl w-full bg-white p-4">

                                {/* Header (Close + Download) */}
                                <div className="flex justify-end gap-2 items-center mb-2">

                                    <button
                                        className="text-sm bg-[#ffffff] px-3 py-1 bg-blue-500 text-white rounded hover:bg-blue-600"
                                        onClick={() => {
                                            const link = document.createElement('a');
                                            link.href = selectedImage;
                                            link.download = 'image.jpg';
                                            link.click();
                                        }}
                                    >
                                        Download
                                    </button>
                                    <button
                                        className="text-gray-600 hover:text-black"
                                        onClick={closeModal}
                                    >
                                        <X size={18} />
                                    </button>
                                </div>

                                {/* Image */}
                                <div className="flex justify-center">
                                    <img
                                        src={selectedImage}
                                        alt="selected"
                                        className="rounded-xl max-h-[70vh] object-contain"
                                    />
                                </div>
                            </div>
                        </div>
                    )}

                </div>

                <div
                    style={{ display: "flex", marginRight: "10px", marginBottom: "10px" }}
                >
                    <div class="header-container">
                        <h2 className="bigtitle">Order Accepted Information</h2>
                    </div>
                </div>
                <div className="form-row">
                    <label className="form-field">
                        Connected Vendor Time:
                        <input
                            type="text"
                            className="form-control"
                            name="charges"
                            value={
                                formatToIST(
                                    formData[serviceDetails]?.connectedVendorFullyTime
                                ) || ""
                            }
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>
                    <label className="form-field">
                        Accepted Vendor Name:
                        <input
                            type="text"
                            className="form-control"
                            name="nonGSTCharge"
                            value={formData[serviceDetails]?.vendorName || ""}
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>
                    <label className="form-field">
                        Accepted Vendor Phone:
                        <input
                            type="text"
                            className="form-control"
                            name="vendorPhone"
                            value={formData[serviceDetails]?.vendorPhone || ""}
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>
                    <label className="form-field">
                        Accepted driver Name:
                        <input
                            type="text"
                            className="form-control"
                            name="nonGSTCharge"
                            value={formData[serviceDetails]?.vendorDriverName || ""}
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>
                    <label className="form-field">
                        Accepted driver Number:
                        <input
                            type="text"
                            className="form-control"
                            name="nonGSTCharge"
                            value={formData[serviceDetails]?.vendorDriverNumber || ""}
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>
                    <label className="form-field">
                        Non GST Charge:
                        <input
                            type="text"
                            className="form-control"
                            name="nonGSTCharge"
                            value={formData[serviceDetails]?.nonGSTCharge || ""}
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>
                    <label className="form-field">
                        Platform Charge:
                        <input
                            type="text"
                            className="form-control"
                            name="nonGSTCharge"
                            value={formData[serviceDetails]?.platformCharge || ""}
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>
                    <label className="form-field">
                        GST Charge:
                        <input
                            type="text"
                            className="form-control"
                            name="nonGSTCharge"
                            value={formData[serviceDetails]?.gstCharges || ""}
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>
                    <label className="form-field">
                        Round Off:
                        <input
                            type="text"
                            className="form-control"
                            name="charges"
                            value={formData[serviceDetails]?.roundOff || ""}
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>

                    <label className="form-field">
                        Charges:
                        <input
                            type="text"
                            className="form-control"
                            name="charges"
                            value={formData[serviceDetails]?.charges || ""}
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>

                    <label className="form-field">
                        Vendor Driver Location To Pick Distance:
                        <input
                            type="text"
                            className="form-control"
                            name="fromVendorLocationToPickDistance"
                            value={
                                `${parseFloat(
                                    formData[serviceDetails]?.fromVendorLocationToPickDistance
                                ).toFixed(2)} KM` || ""
                            }
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>
                    <label className="form-field">
                        Vendor Driver Location To Pick Duration:
                        <input
                            type="text"
                            className="form-control"
                            name="fromVendorLocationToPickDuration"
                            value={
                                formData[serviceDetails]?.fromVendorLocationToPickDuration || ""
                            }
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>
                    <label className="form-field">
                        Pick To Drop Distance:
                        <input
                            type="text"
                            className="form-control"
                            name="fromPickToDropDistance"
                            value={
                                `${parseFloat(
                                    formData[serviceDetails]?.fromPickToDropDistance
                                ).toFixed(2)} KM` || ""
                            }
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>
                    <label className="form-field">
                        Pick To Drop Duration:
                        <input
                            type="text"
                            className="form-control"
                            name="fromPickToDropDuration"
                            value={formData[serviceDetails]?.fromPickToDropDuration || ""}
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>
                    <label className="form-field">
                        Total Distance:
                        <input
                            type="text"
                            className="form-control"
                            name="totalDistance"
                            value={
                                `${parseFloat(formData[serviceDetails]?.totalDistance).toFixed(
                                    2
                                )} KM` || ""
                            }
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>
                    <label className="form-field">
                        Total Duration:
                        <input
                            type="text"
                            className="form-control"
                            name="totalDistance"
                            value={formData[serviceDetails]?.totalDuration || ""}
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>
                </div>

                <div
                    style={{ display: "flex", marginRight: "10px", marginBottom: "10px" }}
                >
                    <div class="header-container">
                        <h2 className="bigtitle">Order Payment Details</h2>
                    </div>
                </div>

                <div className="form-row">
                    <label className="form-field">
                        Customer Accepted Time:
                        <input
                            type="text"
                            className="form-control"
                            name="customerAcceptedVendorTime"
                            value={
                                formatToIST(
                                    formData[serviceDetails]?.customerAcceptedVendorTime
                                ) || ""
                            }
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>
                    <label className="form-field">
                        Order Id:
                        <input
                            type="text"
                            className="form-control"
                            name="orderId"
                            value={formData[serviceDetails]?.orderId || ""}
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>
                    <label className="form-field">
                        Razorpay Order Id:
                        <input
                            type="text"
                            className="form-control"
                            name="razorpay_order_id"
                            value={formData[serviceDetails]?.razorpay_order_id || ""}
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>
                    <label className="form-field">
                        Estimate Amount:
                        <input
                            type="text"
                            className="form-control"
                            name="estimatedAmount"
                            value={formData[serviceDetails]?.estimatedAmount || ""}
                            readOnly={IsReadOnly}
                        />
                    </label>

                    <label className="form-field">
                        Paid Amount:
                        <input
                            type="text"
                            className="form-control"
                            name="paymentAmount"
                            value={formData[serviceDetails]?.paymentAmount || ""}
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>
                    <label className="form-field">
                        Transaction Date:
                        <input
                            type="text"
                            className="form-control"
                            name="transactionDate"
                            value={formData[serviceDetails]?.transactionDate || ""}
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>
                    <label className="form-field">
                        Status:
                        <input
                            type="text"
                            className="form-control"
                            name="charges"
                            value={formData[serviceDetails]?.status || ""}
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>
                    <label className="form-field">
                        Final Bill Amount:
                        <input
                            type="text"
                            className="form-control"
                            name="finalBillAmount"
                            value={formData[serviceDetails]?.finalBillAmount || ""}
                            readOnly={IsReadOnly}
                        />
                    </label>
                    <label className="form-field">
                        Balance to Pay:
                        <input
                            type="text"
                            className="form-control"
                            name="balanceToPay"
                            value={formData[serviceDetails]?.balanceToPay || ""}
                            readOnly={IsReadOnly}
                        />
                    </label>
                    <label className="form-field">
                        Estimate URL:
                        {/* <input
              type="text"
              className="form-control"
              name="estimateUrl"
              value={formData[serviceDetails]?.estimateUrl || ""}
              readOnly={IsReadOnly}
            /> */}
                        <div className="flex gap-3 mt-2">
                            <a
                                href={formData[serviceDetails]?.estimateUrl || "#"}
                                target="_blank"
                                download
                                style={{
                                    cursor: "pointer",
                                    color: "green",
                                    fontSize: "13px",
                                }}
                            >
                                <DownloadingOutlinedIcon /> Download
                            </a>
                            <a
                                href="#"
                                style={{
                                    cursor: "pointer",
                                    border: "none",
                                    background: "white",
                                    color: "#560303",
                                    fontSize: "13px",
                                    boxShadow: "none",
                                }}
                            >
                                <RemoveRedEyeOutlinedIcon />
                                Preview
                            </a>
                        </div>
                    </label>
                    <label className="form-field">
                        Invoice URL:
                        {/* <input
              type="text"
              className="form-control"
              name="systemCreatedInvoice"
              value={formData[serviceDetails]?.systemCreatedInvoice || ""}
              readOnly={IsReadOnly}
            /> */}
                        <div className="flex gap-3 mt-2">
                            <a
                                href={formData[serviceDetails]?.systemCreatedInvoice || "#"}
                                target="_blank"
                                download
                                style={{
                                    cursor: "pointer",
                                    color: "green",
                                    fontSize: "13px",
                                }}
                            >
                                <DownloadingOutlinedIcon /> Download
                            </a>
                            <a
                                href={"#"}
                                style={{
                                    cursor: "pointer",
                                    border: "none",
                                    background: "white",
                                    color: "#560303",
                                    fontSize: "13px",
                                    boxShadow: "none",
                                }}
                            >
                                <RemoveRedEyeOutlinedIcon />
                                Preview
                            </a>
                        </div>
                    </label>
                </div>

                <div
                    style={{ display: "flex", marginRight: "10px", marginBottom: "10px" }}
                >
                    <div class="header-container">
                        <h2 className="bigtitle">
                            Vendor Driver And Customer Communication Details
                        </h2>
                    </div>
                </div>

                <div className="form-row">
                    <label className="form-field">
                        Vendor Driver Moved Time:
                        <input
                            type="text"
                            className="form-control"
                            name="vendorMovedTime"
                            value={
                                formatToIST(formData[serviceDetails]?.vendorMovedTime) || ""
                            }
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>

                    <label className="form-field">
                        Vendor Driver Reached Time:
                        <input
                            type="text"
                            className="form-control"
                            name="vendorMovedTime"
                            value={
                                formatToIST(formData[serviceDetails]?.vendorReachedTime) || ""
                            }
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>
                    <label className="form-field">
                        Vendor Driver Reached Approved By Customer (Reached/Not Reached):
                        <input
                            type="text"
                            className="form-control"
                            name="vendorMovedTime"
                            value={
                                (formData[serviceDetails]?.approvedReaching ? "Yes" : "No") ||
                                ""
                            }
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>
                    <label className="form-field">
                        Customer Action Time (Reached/Not Reached):
                        <input
                            type="text"
                            className="form-control"
                            name="vendorMovedTime"
                            value={
                                formatToIST(formData[serviceDetails]?.approvedReachingTime) ||
                                ""
                            }
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>
                </div>

                <div
                    style={{ display: "flex", marginRight: "10px", marginBottom: "10px" }}
                >
                    <div class="header-container">
                        <h2 className="bigtitle">Vendor Driver Filled Details</h2>
                    </div>
                </div>

                <div className="form-row">
                    <label className="form-field">
                        Details Filled At:
                        <input
                            type="text"
                            className="form-control"
                            name="fuelQuantity"
                            value={
                                formatToIST(formData[serviceDetails]?.detailsFilledAt) || ""
                            }
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>
                    <label className="form-field">
                        Fuel Quantity:
                        <input
                            type="text"
                            className="form-control"
                            name="fuelQuantity"
                            value={formData[serviceDetails]?.fuelQuantity || ""}
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>
                    <label className="form-field">
                        Selected Tools:
                        <input
                            type="text"
                            className="form-control"
                            name="selectedTools"
                            value={(() => {
                                const tools = formData[serviceDetails]?.selectedTools;

                                // if backend gives array already
                                if (Array.isArray(tools)) {
                                    return tools.join(", ");
                                }

                                // if backend gives string that looks like an array
                                if (typeof tools === "string") {
                                    try {
                                        const parsed = JSON.parse(tools);
                                        if (Array.isArray(parsed)) {
                                            return parsed.join(", ");
                                        }
                                    } catch (err) {
                                        // fallback: strip brackets + quotes manually
                                        return tools.replace(/[\[\]"]+/g, "");
                                    }
                                }

                                return "";
                            })()}
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>
                    <label className="form-field">
                        De Selected Tools:
                        <input
                            type="text"
                            className="form-control"
                            name="selectedTools"
                            value={formData[serviceDetails]?.deselectedTools || ""}
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>
                    <label className="form-field">
                        Other Tools:
                        <input
                            type="text"
                            className="form-control"
                            name="selectedTools"
                            value={formData[serviceDetails]?.toolingInfo || ""}
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>
                </div>

                <div
                    style={{ display: "flex", marginRight: "10px", marginBottom: "10px" }}
                >
                    <div class="header-container">
                        <h2 className="bigtitle">Vehicle Images Uploaded By Driver</h2>
                    </div>
                </div>
                <div className="form-row">
                    {formData[serviceDetails]?.vehicleImage &&
                        Object.entries(formData[serviceDetails]?.vehicleImage).map(([title, url]) => {
                            const formattedTitle = title
                                .replace(/([A-Z])/g, " $1") // Add space before capital letters
                                .replace(/^./, (str) => str.toUpperCase()); // Capitalize first letter

                            return (
                                <label className="form-field" key={title}>
                                    {formattedTitle}:
                                    <img
                                        src={url}
                                        alt={title}
                                        onClick={() => openModal(url)}
                                        className="vehicle-image pt-1 cursor-pointer"
                                        style={{
                                            objectFit: "contain",
                                            marginTop: "1rem",
                                            height: "200px",
                                            width: "100%",
                                            boxShadow: "rgba(0, 0, 0, 0.1) 2px 2px 20px 13px",
                                            borderRadius: "10%",
                                        }}
                                    />
                                </label>
                            );
                        })}
                </div>

                <div
                    style={{ display: "flex", marginRight: "10px", marginBottom: "10px" }}
                >
                    <div class="header-container">
                        <h2 className="bigtitle">Tyres Images Uploaded By Driver</h2>
                    </div>
                </div>
                <div className="form-row">
                    {formData[serviceDetails]?.tyresImage &&
                        Object.entries(formData[serviceDetails]?.tyresImage).map(
                            ([title, url]) => {
                                const formattedTitle = title
                                    .replace(/([A-Z])/g, " $1") // Add space before capital letters
                                    .replace(/^./, (str) => str.toUpperCase()); // Capitalize first letter

                                return (
                                    <label className="form-field" key={formattedTitle}>
                                        {formattedTitle}:
                                        <img
                                            src={url}
                                            alt={formattedTitle}
                                            onClick={() => openModal(url)}
                                            className="vehicle-image pt-1 cursor-pointer"
                                            style={{
                                                objectFit: "contain",
                                                marginTop: "1rem",
                                                objectFit: "contain",
                                                marginTop: "1rem",
                                                height: "200px",
                                                width: "100%",
                                                boxShadow: "rgba(0, 0, 0, 0.1) 2px 2px 20px 13px",
                                                borderRadius: "10%",
                                                boxShadow: "rgba(0, 0, 0, 0.1) 2px 2px 20px 13px",
                                                borderRadius: "10%",
                                            }}
                                        />
                                    </label>)   
                            }
                        )}
                </div>

                <div
                    style={{ display: "flex", marginRight: "10px", marginBottom: "10px" }}
                >
                    <div class="header-container">
                        <h2 className="bigtitle">Confirm Details By Customer</h2>
                    </div>
                </div>
                <div className="form-row">
                    <label className="form-field">
                        Confirmed Correct Details (Approved / Not Approved):
                        <input
                            type="text"
                            className="form-control"
                            name="approvedRightlyMeasured"
                            value={
                                (formData[serviceDetails]?.approvedRightlyMeasured
                                    ? "Yes"
                                    : "No") || ""
                            }
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>
                    <label className="form-field">
                        Confirmed Correct Details Time (Approved / Not Approved):
                        <input
                            type="text"
                            className="form-control"
                            name="approvedRightlyMeasuredTime"
                            value={
                                formatToIST(
                                    formData[serviceDetails]?.approvedRightlyMeasuredTime
                                ) || ""
                            }
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>
                </div>

                <div
                    style={{ display: "flex", marginRight: "10px", marginBottom: "10px" }}
                >
                    <div class="header-container">
                        <h2 className="bigtitle">Done working</h2>
                    </div>
                </div>
                <div className="form-row">
                    <label className="form-field">
                        Work Done By Driver (Done / Not Done):
                        <input
                            type="text"
                            className="form-control"
                            name="doneWorking"
                            value={
                                (formData[serviceDetails]?.doneWorking ? "Yes" : "No") || ""
                            }
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>
                    <label className="form-field">
                        Work Done By Driver Time:
                        <input
                            type="text"
                            className="form-control"
                            name="doneWorkingTime"
                            value={
                                formatToIST(formData[serviceDetails]?.doneWorkingTime) || ""
                            }
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>
                    <label className="form-field">
                        Confirming Work Done By Customer (Approved / Not Approved):
                        <input
                            type="text"
                            className="form-control"
                            name="approvedRightlyMeasured"
                            value={
                                (formData[serviceDetails]?.confirmDoneWorking ? "Yes" : "No") ||
                                ""
                            }
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>
                    <label className="form-field">
                        Confirming Work Done By Customer Time (Approved / Not Approved):
                        <input
                            type="text"
                            className="form-control"
                            name="approvedRightlyMeasuredTime"
                            value={
                                formatToIST(formData[serviceDetails]?.confirmDoneWorkingTime) ||
                                ""
                            }
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>

                    <label className="form-field">
                        List Of Issue (Approved / Not Approved):
                        <input
                            type="text"
                            className="form-control"
                            name="listOfIssues"
                            value={
                                // (formData[serviceDetails]?.listOfIssues) || ""
                                (formData[serviceDetails]?.listOfIssues || "")
                                    .split(",")
                                    .map((item) => item.trim())
                                    .filter((item) => item && item !== "undefined")
                                    .join(", ")
                            }
                            required
                            readOnly={IsReadOnly}
                        />
                    </label>
                </div>

                {alertInfo.show && (
                    <Alert
                        severity={alertInfo.severity}
                        onClose={() => setAlertInfo({ ...alertInfo, show: false })}
                    >
                        {alertInfo.message}
                    </Alert>
                )}
            </form>
        </div>
    );
};

export default ViewVehicleJourneyInfo;
